var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_37035)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2963_37035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 68C27.79 68 26 66.21 26 64C26 61.79 27.79 60 30 60C32.21 60 34 61.79 34 64C34 66.21 32.21 68 30 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 66C30.2663 66.006 30.5311 65.9588 30.779 65.861C31.0268 65.7633 31.2526 65.617 31.4431 65.4308C31.6336 65.2446 31.785 65.0222 31.8884 64.7766C31.9918 64.5311 32.0451 64.2674 32.0452 64.001C32.0452 63.7346 31.9921 63.4708 31.8888 63.2253C31.7855 62.9797 31.6343 62.7572 31.4438 62.5709C31.2534 62.3846 31.0277 62.2382 30.7799 62.1403C30.5321 62.0425 30.2673 61.9951 30.0009 62.001C29.4784 62.0125 28.9811 62.2282 28.6156 62.6018C28.25 62.9754 28.0453 63.4773 28.0452 64C28.045 64.5227 28.2495 65.0246 28.6149 65.3984C28.9802 65.7722 29.4774 65.9882 30 66Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 34.2V39H39.4C39.4788 39 39.5568 38.9845 39.6296 38.9543C39.7024 38.9242 39.7685 38.88 39.8243 38.8243C39.88 38.7685 39.9242 38.7024 39.9543 38.6296C39.9845 38.5568 40 38.4788 40 38.4V24.6C40 24.5212 39.9845 24.4432 39.9543 24.3704C39.9242 24.2976 39.88 24.2315 39.8243 24.1757C39.7685 24.12 39.7024 24.0758 39.6296 24.0457C39.5568 24.0155 39.4788 24 39.4 24H34.446L34.288 26H38V27H34.21L34.051 29H38V30H33.972L33.599 34.715C33.5966 34.7549 33.5863 34.7939 33.5687 34.8299C33.5512 34.8658 33.5267 34.8978 33.4966 34.9242C33.4666 34.9506 33.4317 34.9708 33.3938 34.9837C33.3559 34.9965 33.3159 35.0017 33.276 34.999C33.1996 34.9915 33.1289 34.9555 33.0778 34.8983C33.0266 34.8411 32.9989 34.7667 33 34.69V18.4C33 18.2939 32.9579 18.1922 32.8828 18.1172C32.8078 18.0421 32.7061 18 32.6 18H32V17.4C32 17.2939 31.9579 17.1922 31.8828 17.1172C31.8078 17.0421 31.7061 17 31.6 17H21.4C21.2939 17 21.1922 17.0421 21.1172 17.1172C21.0421 17.1922 21 17.2939 21 17.4V18H20.4C20.2939 18 20.1922 18.0421 20.1172 18.1172C20.0421 18.1922 20 18.2939 20 18.4V38.4C20 38.5591 20.0632 38.7117 20.1757 38.8243C20.2883 38.9368 20.4409 39 20.6 39H25V34.2C25 34.09 25.09 34 25.2 34H27.8C27.91 34 28 34.09 28 34.2ZM23.5 31V25H25.5V31H23.5ZM27.5 25V31H29.5V25H27.5ZM23.5 23V20H25.5V23H23.5ZM27.5 20V23H29.5V20H27.5ZM35 33V32H38V33H35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5259 23L34.6049 22H37.5999C37.8199 22 37.9999 22.18 37.9999 22.4V23H34.5259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2963_37035",
    x: 1,
    y: -1,
    width: 58,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_2963_37035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_37035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectIcon);
export default __webpack_public_path__ + "static/media/objectIcon.7d0c38647072d355c638f2ce2a32d26a.svg";
export { ForwardRef as ReactComponent };